import   React      ,
       { useRef     ,
         useState   }  from "react";

import   styles       from "./SentEmailList.module.scss";

interface SentEmailPreviewFrameProps {
  bodyHtml: string;
}

// Rendu dans une <iframe srcDoc> plutôt qu'injecté directement dans le DOM : bodyHtml
// porte son propre <style> (celui du template email) — l'injecter tel quel dans une div
// ferait fuiter ces styles sur le reste de l'écran admin-front. L'iframe s'agrandit à la
// hauteur réelle du contenu une fois chargée pour éviter une double barre de défilement.
export const SentEmailPreviewFrame: React.FC<SentEmailPreviewFrameProps> = ({ bodyHtml }) => {

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [ height , setHeight ] = useState(400);

  const handleLoad = () => {
    const doc = iframeRef.current?.contentDocument;

    if (doc?.body) {
      setHeight(doc.body.scrollHeight + 20);
    }
  };

  return (
    <iframe
      ref={iframeRef}
      className={styles.previewFrame}
      style={{ height: `${height}px` }}
      srcDoc={bodyHtml}
      onLoad={handleLoad}
      sandbox=""
      title="Aperçu de l'email"
    />
  );
};

export default SentEmailPreviewFrame;
